
import { TimeSpan } from '@sparkware/app-utils';
import { ServiceBase } from './../ServiceBase';
import { IRegulationService } from './regulation.service.interface';

export class RegulationService extends ServiceBase implements IRegulationService {
    getRegulationCode(): number {
        return this.services.sdk.getRegulationService().getRegulationCode();
    }

    isUSRegulation(): boolean {
        return this.services.sdk.getRegulationService().isUSRegulation();
    }

    getSessionCooldownConfig(): { featureEnabled: boolean; cooldownTime: TimeSpan } {

        const sessionCooldownConfig = this.services.sdk.getRegulationService().getSessionCooldownConfig();

        return {
            ...sessionCooldownConfig,
            cooldownTime: TimeSpan.parse(sessionCooldownConfig.cooldownTime)
        };
    }


    shouldShowPlayerLimitsToaster(): boolean {
        return this.services.sdk.getRegulationService().shouldShowPlayerLimitsToaster();
    }

    shouldReplaceLoginWithDownloadAppForMobileWebApp(): boolean {
        return this.services.sdk.getSkin().shouldReplaceLoginWithDownloadAppForMobileWebApp();
    }

    shouldPreventOpenGameForMobileWebApp(): boolean {
        return this.services.sdk.getSkin().shouldPreventOpenGameForMobileWebApp();
    }
}
